import React from 'react';
import './styles/TreatmentHistory.css';

const TreatmentHistory = () => {
  return (
    <div>TreatmentHistory</div>
  )
}

export default TreatmentHistory